import { useEffect, useLayoutEffect, useRef, useState } from 'react';

export const SCREEN_HEADER_TITLE_MAX_CHARS = 20;

const TITLE_TRUNCATED_STAGE = 1;
const STATUS_COLLAPSED_STAGE = 2;
const TRAILING_TRUNCATED_STAGE = 3;
const TRAILING_HIDDEN_STAGE = 4;
const OVERFLOW_TOLERANCE = 1;

export const useScreenHeaderCompression = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [stage, setStage] = useState(0);

  useLayoutEffect(() => {
    const content = contentRef.current;

    if (!content || stage >= TRAILING_HIDDEN_STAGE) {
      return;
    }

    if (content.scrollWidth > content.clientWidth + OVERFLOW_TOLERANCE) {
      setStage((currentStage) => currentStage + 1);
    }
  });

  useEffect(() => {
    const content = contentRef.current;

    if (!content) {
      return;
    }

    const observer = new ResizeObserver(() => setStage(0));
    observer.observe(content);

    return () => observer.disconnect();
  }, []);

  return {
    contentRef,
    isTitleTruncated: stage >= TITLE_TRUNCATED_STAGE,
    isStatusCollapsed: stage >= STATUS_COLLAPSED_STAGE,
    isTrailingTruncated: stage >= TRAILING_TRUNCATED_STAGE,
    isTrailingHidden: stage >= TRAILING_HIDDEN_STAGE,
  };
};
